import React from 'react';
import PropTypes from 'prop-types';
import {Button, Box, Flex, Heading, Text} from '@spothero/ui';
import {PROPTYPE_EVENT_PACKAGE} from '@/proptypes/index';
import {useSelector} from 'react-redux';
import MobileToggle from 'common/search-filters-controls/mobile-toggle';
import useIsMobile from 'hooks/use-is-mobile';
import {SearchPageView} from 'utils/search-page-view';

const EventPackageDetailsCondensed = ({eventPackage, onClick}) => {
    const {title, description} = eventPackage;
    const isMobile = useIsMobile();
    const {view: searchPageView} = useSelector(s => s.search.data);

    return (
        <Box
            className="event-package-info"
            position="relative"
            top={{
                base: 'header-height-mobile',
                tablet: 'header-height-desktop',
            }}
            padding="4"
            width={{base: 'auto', tablet: 'zone-1-width-desktop'}}
            boxShadow="md"
            backgroundColor="white"
        >
            <Flex justifyContent="space-between">
                <Flex overflow="hidden" flexDirection="column" marginRight="4">
                    <Heading
                        as="h3"
                        variant="h6"
                        marginBottom="1"
                        color="gray.dark"
                    >
                        {title}
                    </Heading>
                    <Text
                        marginBottom="0"
                        fontSize="base"
                        fontWeight="semibold"
                        overflow="hidden"
                        textOverflow="ellipsis"
                        whiteSpace="nowrap"
                    >
                        {description}
                    </Text>
                </Flex>
                <Flex alignItems="center">
                    <Button variant="secondary" onClick={onClick}>
                        View
                    </Button>
                </Flex>
            </Flex>
            {isMobile && searchPageView === SearchPageView.MOBILE_MAP ? (
                <Box paddingTop={4}>
                    <MobileToggle />
                </Box>
            ) : null}
        </Box>
    );
};

EventPackageDetailsCondensed.propTypes = {
    eventPackage: PROPTYPE_EVENT_PACKAGE.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default EventPackageDetailsCondensed;
